import React from 'react';
import { cn } from '@rocco/utils/cn';
import type { ProductPriceTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import { formatPriceForProductTilePrice } from '@rocco/utils/format-price';

interface ProductTilePriceProps {
    price: ProductPriceTileViewModel | null;
    /** Portrait browse tiles tighten the mobile price row; legacy tiles keep the default scale. */
    compact?: boolean;
}

export const ProductTilePrice = ({ price, compact }: ProductTilePriceProps) => {
    // if price == null - we have `Price on Request` situation for this item - show nothing
    if (!price) {
        return null;
    }

    // we have some pricing - let's show it :)
    const hasDiscount =
        price.discountedAmount > 0 && price.discountedAmount < price.amount;

    return (
        <div
            className={cn(
                'flex gap-2 text-sm leading-none font-medium md:text-base',
                compact && 'max-md:gap-1 max-md:text-[0.75rem]',
            )}
        >
            {price.prefix && <span>{price.prefix}</span>}

            {hasDiscount && (
                <span className="text-gray-500 line-through">
                    {formatPriceForProductTilePrice(
                        price.amount,
                        price.currency,
                        true,
                    )}
                </span>
            )}

            <span className={cn(hasDiscount && 'text-brick-50')}>
                {formatPriceForProductTilePrice(
                    hasDiscount ? price.discountedAmount : price.amount,
                    price.currency,
                    true,
                )}
            </span>
        </div>
    );
};
